<template>
  <div class="ListViewer_viewer">
    <div class="board_view">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListViewer',
  components: {

  },
  data: () => ({

  }),
  methods: {

  },
  mounted() {

  }
}
</script>

<style>
.ListViewer_viewer {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
}
.board_view {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  height: calc(100vh - 153px);
  max-height: calc(100vh - 153px);
  padding: 12px;
  align-items: flex-start;
  overflow-x: auto;
  overscroll-behavior-x: none;
}
.board_view::-webkit-scrollbar {
  width: 3px;
  height: 8px;
}

.board_view::-webkit-scrollbar-track {
  background-color: rgba(238, 238, 238, 0.09);
}

.board_view::-webkit-scrollbar-thumb {
  background-color: rgba(57, 57, 57, 0.2);
}
.horizontal-view {
  display: flex;
}
.absolute-loader {
  position: absolute;
  left: 12px;

}
</style>